import { TreeInstance } from '@headless-tree/core';
import React, { useMemo, useState } from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list/types';

import { Context } from './context';

export type ProviderProps = {
  children: React.ReactNode;
};

export const Provider: React.FC<ProviderProps> = ({ children }) => {
  const [tree, setTree] = useState<TreeInstance<InternalTreeItem>>();

  const value = useMemo(() => ({ tree, setTree }), [tree]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
